import { Ride } from '@geovelo-frontends/commons';
import { Box, ButtonBase } from '@mui/material';
import { Link } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { RidesHubByDepartmentQuery } from '../../../graphql-types';
import RideCard from '../../components/ride-card';
import Seo from '../../components/seo';
import Banner from '../../components/slices/banner';
import { maxWidth } from '../../components/slices/consts';
import environment from '../../environment';
import { TPageProps } from '../../page-props';
import { parseRide } from '../../utils/ride';
import Breadcrumb from '../rides-hub/breadcrumb';

function RideHubByDepartmentPage(props: TPageProps<RidesHubByDepartmentQuery>): React.JSX.Element {
  const [rides] = useState(() => {
    return props.data.allRide.nodes.reduce<Ride[]>((res, { data }) => {
      if (data) {
        res.push(parseRide(data, environment.backendUrl));
      }

      return res;
    }, []);
  });
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation();

  const title = `${t(`geovelo.rides_hub.departments_list.title`)} | ${
    props.data.department?.data?.name
  }`;
  const bannerData = props.data.prismicRidesHub?.data.body.find(
    ({ slice_type }) => slice_type === 'banner',
  );

  return (
    <>
      <Seo title={title} {...props} />
      {bannerData && (
        <Banner
          small
          breadcrumb={<Breadcrumb items={[{ label: props.data.department?.data?.name || '' }]} />}
          data={{
            ...bannerData,
            primary: {
              ...bannerData.primary,
              baseline: { text: props.data.department?.data?.name },
            },
          }}
        />
      )}
      <Box
        display="flex"
        flexDirection="column"
        gap={{ xs: 6, lg: 8 }}
        paddingBottom={{ xs: 6, lg: 8 }}
        paddingTop={{ xs: 6, lg: 8 }}
      >
        <Box alignItems="center" alignSelf="stretch" display="flex" flexDirection="column">
          <Box
            display="flex"
            flexDirection="column"
            gap={5}
            maxWidth="100%"
            paddingX={{ xs: 4, md: 8, lg: 16 }}
            width={maxWidth}
          >
            <Box display="flex" flexWrap="wrap" gap={2} justifyContent="center">
              {rides.map((ride) => (
                <Box
                  key={ride.id}
                  sx={{
                    width: {
                      xs: '100%',
                      md: 'calc((100% - 16px) / 2)',
                      lg: 'calc((100% - 32px) / 3)',
                    },
                  }}
                >
                  <ButtonBase
                    component={Link}
                    sx={{ height: '100%', width: '100%' }}
                    to={`/${currentLanguage}/rides/${ride.id}`}
                  >
                    <RideCard fullHeight outlined ride={ride} />
                  </ButtonBase>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default withPrismicPreview(RideHubByDepartmentPage);
